export { default as Fade } from './fade';
